import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { KgValue } from './KgValue';
import { cn } from '@/lib/utils';
import type { KgString } from '@/lib/kg';

interface KgCardProps {
  label: string;
  value: KgString | null | undefined;
  tone?: 'default' | 'success' | 'warning' | 'error' | 'critical' | 'muted';
  className?: string;
}

/**
 * Large-digit kg display card for dashboard widgets.
 */
export const KgCard = ({ label, value, tone = 'default', className }: KgCardProps) => {
  return (
    <Card className={cn('min-w-0', className)}>
      <CardHeader className="pb-1 pt-3 px-4">
        <CardTitle className="text-xs font-medium text-efs-text-muted uppercase tracking-wide">
          {label}
        </CardTitle>
      </CardHeader>
      <CardContent className="px-4 pb-3">
        <span className="text-2xl font-semibold">
          <KgValue value={value} tone={tone} fractionDigits={3} />
        </span>
      </CardContent>
    </Card>
  );
};
